const { getBrandByKey } = require("./resolveBrand");

const TOKEN_READERS = {
  brandName: (brand) => brand.brandName,
  brandNamePlain: (brand) => brand.brandNamePlain,
  brandNameUppercase: (brand) => brand.brandNameUppercase,
  brandSlug: (brand) => brand.brandSlug,
  consumerDomain: (brand) => brand.consumerDomain,
  contractorDomain: (brand) => brand.contractorDomain,
  shopDomain: (brand) => brand.shopDomain,
  consumerBaseUrl: (brand) => brand.consumerBaseUrl,
  contractorBaseUrl: (brand) => brand.contractorBaseUrl,
  shopBaseUrl: (brand) => brand.shopBaseUrl,
  displayDomain: (brand) => brand.displayDomain,
  legalEntityName: (brand) => brand.legalEntityName,
  copyrightName: (brand) => brand.copyrightName,
};

function resolveBrandInput(brandInput) {
  return typeof brandInput === "string"
    ? getBrandByKey(brandInput)
    : getBrandByKey(brandInput?.brandKey);
}

function interpolateBrandText(value, brandInput) {
  if (typeof value !== "string") {
    return value;
  }

  const brand = resolveBrandInput(brandInput);

  return value.replace(/\{\{([a-zA-Z0-9_]+)\}\}/g, (match, token) => {
    const reader = TOKEN_READERS[token];
    return reader ? reader(brand) : match;
  });
}

function interpolateBrandContent(value, brandInput) {
  if (typeof value === "string") {
    return interpolateBrandText(value, brandInput);
  }

  if (Array.isArray(value)) {
    return value.map((item) => interpolateBrandContent(item, brandInput));
  }

  if (value && typeof value === "object") {
    return Object.entries(value).reduce((accumulator, [key, entry]) => {
      accumulator[key] = interpolateBrandContent(entry, brandInput);
      return accumulator;
    }, {});
  }

  return value;
}

module.exports = {
  interpolateBrandContent,
  interpolateBrandText,
};
